export const SuccessGradient = (props) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0_13186_67024)">
      <path
        d="M37.1871 54.3715C37.166 54.3715 37.1449 54.3715 37.1227 54.3706C36.3025 54.3535 35.5247 54.0028 34.9689 53.3987L19.793 36.9173C18.6654 35.6921 18.7438 33.7846 19.9689 32.657C21.195 31.5293 23.1016 31.6087 24.2293 32.8329L37.2796 47.0068L73.4504 10.9313C74.6272 9.75541 76.5368 9.75744 77.7136 10.9364C78.8896 12.1153 78.8875 14.0248 77.7075 15.2007L39.3157 53.4921C38.7508 54.0549 37.9841 54.3715 37.1871 54.3715Z"
        fill="url(#paint0_linear_13186_67024)"
      />
      <path
        d="M40 80C17.9438 80 0 62.0553 0 40C0 17.9437 17.9438 0 40 0C41.6653 0 43.015 1.34969 43.015 3.015C43.015 4.68031 41.6653 6.03016 40 6.03016C21.2694 6.03016 6.03016 21.2694 6.03016 40C6.03016 58.7317 21.2694 73.9698 40 73.9698C58.7317 73.9698 73.9699 58.7317 73.9699 40C73.9699 38.3347 75.3195 36.985 76.9848 36.985C78.6502 36.985 79.9998 38.3347 79.9998 40C80 62.0553 62.0553 80 40 80Z"
        fill="url(#paint1_linear_13186_67024)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_13186_67024"
        x1="18.9961"
        y1="32.2127"
        x2="78.5972"
        y2="32.2127"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#619355" />
        <stop offset="1" stop-color="#619355" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_13186_67024"
        x1="0"
        y1="40.0027"
        x2="80.004"
        y2="40.0027"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#619355" />
        <stop offset="1" stop-color="#619355" />
      </linearGradient>
      <clipPath id="clip0_13186_67024">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
